import { render, staticRenderFns } from "./stripe-return.vue?vue&type=template&id=b2ac0c1c"
import script from "./stripe-return.vue?vue&type=script&lang=js"
export * from "./stripe-return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports